<template lang="pug">
section#kennel-cal.calendar
	//- Calendar Header
	.header
		.left
			slot(name="header-left")
		.month-selector
			span.icon.arrow.left(@click="adjustMonth(-1)")
				include ../resources/icons/chevron-down.pug
			span.selected-month {{ CONSTS.Months[timeframe.month] }} {{ timeframe.year }}
			span.icon.arrow.right(@click="adjustMonth()")
				include ../resources/icons/chevron-down.pug
		.right
			slot(name="header-right")
	//- Actual container
	.dates-container
		.row-container
			.row.day-header
				span.day.lg(
					v-for="(day, index) in CONSTS.Days"
					:key="`d-${index}`"
				) {{ day }}
				span.day.sm-md(
					v-for="(day, i) in CONSTS.DAYS_ABBRV"
					:key="`da-${i}`"
				) {{ day }}
		.row-container(
			v-for="index in currentWeeksInMonth"
			:key="`w-${index-1}`"
		)
			//- Background (date number, box)
			.row.row-fill
				template(
					v-for="day, ix in daysOfWeek(timeframe.year, timeframe.month, index-1)"
					:key="`dw-${ix}`"
				)
					.day-bg(
						:class="{'out-of-month': day.getMonth() !== timeframe.month}"
						@click="handleClick(day)"
					)
						KennelCount(:day="day.getDate()" :month="day.getMonth()" :year="day.getFullYear()" :kennel="kennel")
	Modal(v-if="currentKennelCount" @close="currentKennelCount = null")
		KennelCountModal(:date="currentKennelCount" @close="currentKennelCount = null")
</template>

<script setup lang="ts">
import { weeksInMonth, daysOfWeek, CONSTS, Dogspaces} from '@busy-human/k9-library';
import { computed, ref } from 'vue';
import KennelCount from './kennel-count.vue';
import KennelCountModal from './kennel-count-modal.vue';
import Modal from './Modal.vue';


type Props = {
	timeframe: { month: number, year: number }
	kennel: Dogspaces.Sizes
}
type Emits = {
	(e: 'selectEvent', eventId: string): void
	(e: 'update:timeframe', timeframe: Props["timeframe"]): void
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const currentKennelCount = ref<null | {day: number, month: number, year: number}>(null);
function handleClick(date: Date) {
	currentKennelCount.value = {
		day: date.getDate(),
		month: date.getMonth(),
		year: date.getFullYear()
	};
	console.log(currentKennelCount.value);
}

// -- Computed
const currentWeeksInMonth = computed(() => weeksInMonth(props.timeframe.year, props.timeframe.month));

// -- user intraction
const adjustMonth = (delta = 1) => {
	const tmp = new Date(props.timeframe.year, props.timeframe.month + delta, 1);
	emit('update:timeframe', { year: tmp.getFullYear(), month: tmp.getMonth() });
};

</script>

<!--
/* SCSS moved to management-portal/src/stylesheets/components/calendar.scss */
-->